import type { ReminderSettingEntity } from '../../domain/entities/ReminderSettingEntity'
import { ReminderSettingRepository } from '../../domain/repositories/ReminderSettingRepository'
import { ReminderSettingModel } from '../models/ReminderSettingModel'
import { ReminderSettingsService } from '@/backend/market'
import { UpdateReminderSettingModel } from '../models/UpdateReminderSettingModel'

export class ReminderSettingRepositoryImpl implements ReminderSettingRepository {
  async getReminderSetting(): Promise<ReminderSettingModel | { error: true }> {
    try {
      const response = await ReminderSettingsService.getReminderSettingsAdmin()
      const reminderSettingModel = new ReminderSettingModel(response)

      return reminderSettingModel
    } catch {
      return { error: true }
    }
  }
  async updateReminderSetting(
    reminderSetting: ReminderSettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const reminderSettingModel = new UpdateReminderSettingModel(reminderSetting)
    try {
      await ReminderSettingsService.postReminderSettingAdmin({
        requestBody: reminderSettingModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
